import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MemberDashboard from './pages/MemberDashboard';
import RenewalPage from './pages/RenewalPage';
import AdminDashboard from './pages/AdminDashboard';
import MetaAdmin from './pages/MetaAdmin';
// Shown for any address matching no route (replaces a silent redirect to /login)
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/register/:tenant_slug" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* Protected: members */}
        <Route path="/dashboard" element={
          <ProtectedRoute roles={['member']} element={<MemberDashboard />} />
        } />
        <Route path="/renew" element={
          <ProtectedRoute roles={['member']} element={<RenewalPage />} />
        } />

        {/* Protected: tenant admins */}
        <Route path="/admin" element={
          <ProtectedRoute roles={['tenantadmin']} element={<AdminDashboard />} />
        } />

        {/* Protected: meta admin */}
        <Route path="/meta" element={
          <ProtectedRoute roles={['metaadmin']} element={<MetaAdmin />} />
        } />

        {/* Default */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        {/* This used to redirect to /login, which made a dead link
            indistinguishable from "please sign in" - see NotFoundPage. */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
